import { classNames } from 'libs/react';
import { Icon } from 'components/Icon';
import { Case } from 'components/util/Case';
import { Else } from 'components/util/Else';
import { When } from 'components/util/When';
import { React } from 'libs/react';
import './SaleItemIcon.scss';
/**
 * @component SaleItemIcon
 * @since 1.0.0
 */
export function SaleItemIcon(props) {
    const { style, item } = Object.assign({ style: 'normal' }, props);
    const className = classNames('sale-item-icon', 'sale-item-icon--' + style, props.className);
    const icon = item.image ? item.image.image.thumbnail : '';
    return (React.createElement("div", { className: className },
        React.createElement(When, null,
            React.createElement(Case, { is: icon },
                React.createElement("div", { className: "sale-item-icon-image", style: { backgroundImage: `url("${icon}")` } })),
            React.createElement(Else, null,
                React.createElement(Icon, { className: "sale-item-icon-empty", value: "fal barcode" })))));
}
